/* eslint-disable react-refresh/only-export-components */
// apps/vendor/src/router/index.tsx
import { createBrowserRouter, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import { PageSkeleton } from "../components/ui/PageSkeleton";

const LoginPage = lazy(() => import("../pages/auth/LoginPage"));
const RegisterPage = lazy(() => import("../pages/auth/RegisterPage"));
const ForgotPasswordPage = lazy(
  () => import("../pages/auth/ForgotPasswordPage"),
);
const ResetPasswordPage = lazy(() => import("../pages/auth/ResetPasswordPage"));
const VendorLayout = lazy(() => import("../components/layout/VendorLayout"));
const DashboardPage = lazy(() => import("../pages/dashboard/DashboardPage"));
const LoadsPage = lazy(() => import("../pages/loads/LoadsPage"));
const LoadDetailPage = lazy(() => import("../pages/loads/LoadDetailPage"));
const FleetPage = lazy(() => import("../pages/fleet/FleetPage"));
const VehicleDetailsPage = lazy(
  () => import("../pages/fleet/VehicleDetailsPage"),
);
const VendorProfilePage = lazy(
  () => import("../pages/profile/VendorProfilePage"),
);
const DriversPage = lazy(() => import("../pages/drivers/DriversPage"));
const DriverDetailPage = lazy(
  () => import("../pages/drivers/DriverDetailPage"),
);
const EarningsPage = lazy(() => import("../pages/earnings/EarningsPage"));
const LRDetailPage = lazy(() => import("../pages/lorry-receipts/LRDetailPage"));
const LRListPage = lazy(() => import("../pages/lorry-receipts/LRListPage"));
const CreateLRPage = lazy(() => import("../pages/lorry-receipts/CreateLRPage"));
const NotificationsPage = lazy(
  () => import("../pages/notifications/NotificationsPage"),
);
const TrackingPage = lazy(() => import("../pages/tracking/TrackingPage"));
const NotFoundPage = lazy(() => import("../pages/error/NotFoundPage"));
const ServerErrorPage = lazy(() => import("../pages/error/ServerErrorPage"));
const MaintenancePage = lazy(() => import("../pages/error/MaintenancePage"));
const VehicleLogPage = lazy(() => import("../pages/reports/VehicleLogPage"));

const PoliceFinesPage = lazy(() => import("../pages/fines/PoliceFinesPage"));

const S = (C: React.ComponentType) => (
  <Suspense fallback={<PageSkeleton />}>
    <C />
  </Suspense>
);

export const router = createBrowserRouter([
  { path: "/login", element: S(LoginPage) },
  { path: "/register", element: S(RegisterPage) },
  { path: "/forgot-password", element: S(ForgotPasswordPage) },
  { path: "/auth/reset-password", element: S(ResetPasswordPage) },
  {
    path: "/",
    element: S(VendorLayout),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: "dashboard", element: S(DashboardPage) },
      { path: "loads", element: S(LoadsPage) },
      { path: "loads/:id", element: S(LoadDetailPage) },
      { path: "fleet", element: S(FleetPage) },
      { path: "fleet/details", element: S(FleetPage) },
      { path: "fleet/:id", element: S(VehicleDetailsPage) },
      { path: "profile", element: S(VendorProfilePage) },
      { path: "drivers", element: S(DriversPage) },
      { path: "drivers/:id", element: S(DriverDetailPage) },
      { path: "earnings", element: S(EarningsPage) },
      { path: "lorry-receipts", element: S(LRListPage) },
      { path: "lorry-receipts/create", element: S(CreateLRPage) },
      { path: "lorry-receipts/:id", element: S(LRDetailPage) },
      { path: "notifications", element: S(NotificationsPage) },
      { path: "tracking/:shipmentId", element: S(TrackingPage) },
      { path: "vehicle-log", element: S(VehicleLogPage) },
      { path: "vehicle-log/:vehicleId", element: S(VehicleLogPage) },
      { path: "police-fines", element: S(PoliceFinesPage) },
    ],
  },
  { path: "/500", element: S(ServerErrorPage) },
  { path: "/maintenance", element: S(MaintenancePage) },
  { path: "*", element: S(NotFoundPage) },
]);

// Day 75 complete
